export const blue5 = '#2f70cf';
export const tipRed = '#FF6666';
